import { actionCreatorFactory } from 'typescript-fsa';
import { AnalysisType } from '../../types/analysis';
import { CardElementType, CardIdToSelectionMap } from '../../types/cards';

const actionCreator = actionCreatorFactory('teacher-ui');

export const setCardType = actionCreator<AnalysisType>('SET_CARD_TYPE');

export type CardSettingsPayload = {minUsers: number, minPercent: number};
export const saveCardSettings = actionCreator<CardSettingsPayload>('SAVE_CARD_SETTINGS');


export type DashboardLoadPayload = {
    cards: CardIdToSelectionMap,
    cardSettings: CardSettingsPayload
};
/**
 * Firestore documents related to dashboard settings loaded
 */
export const dashboardSettingsLoaded = actionCreator<DashboardLoadPayload>('DASHBOARD_SETTINGS_LOADED');

export const generateReport = actionCreator<CardElementType[]>('GENERATE_REPORT');
export const hideReport = actionCreator('HIDE_REPORT');
